import React, { memo, useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import classNames from 'classnames';
import { CONTEXT } from '../config';
import SoftCardSearch from '../components/SoftCardSearch/SoftCardSearch';
import styles from './LenovoWords.module.less';
import { logging, logPostInfo } from '../actions/log';

const selectLenovoWords = createSelector(
  state => state.search,
  search => search.lenovoWords,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(props => {
  const dispatch = useDispatch();
  const lenovoWords = useSelector(selectLenovoWords);
  const logInfoData = useSelector(selectLogInfo);

  /**
   * 联想词展示打桩
   */
  useEffect(() => {
    let bizInfo = {};
    const lenovoWordArr = [];
    if (
      props.value &&
      lenovoWords.kw === props.value &&
      lenovoWords.data &&
      lenovoWords.data.length > 0
    ) {
      lenovoWords.data.map((v, i) => {
        if (i > 0) {
          bizInfo = v.bizInfo;
          lenovoWordArr.push(v.keyWord);
        }
      });
      dispatch(
        logging({
          category: 'I',
          action: 'Search_Lenovo_Word',
          label: '',
          param2: {
            source: 'Search',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            search_type: 2,
            search_word: props.value,
            lenovo_words: lenovoWordArr.slice(0, 6).join(','),
          },
          param3: bizInfo,
        }),
      );
    }
  }, [dispatch, props, lenovoWords]);

  const handleStopProp = useCallback(ev => {
    ev.stopPropagation();
  }, []);

  // 1. 联系词softcard 做特殊处理 (即：将其作为搜索结果点击进入详情处理)
  // 首位应用进入详情页面的时候，重置两次logPostInfo（即：让source，source_p，source_p后移一步，logInfo.source = 'Search'）
  // 详情页中通过source_p==='Search'判断来源是否来自搜索
  const handleSoft = useCallback(
    (v, index) => {
      if (index !== 0) {
        // 联想词点击
        dispatch(
          logging({
            category: 'C',
            action: 'Search_Lenovo_Word',
            label: '',
            param2: {
              source: 'Search',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              search_type: 6,
              search_word: props.value,
              lenovo_word: v.keyWord,
            },
            param3: v.bizInfo,
          }),
        );
      }
      /**
       * search_type
       * 1: 热词
       * 2: 普通联想词
       * 3: 搜索词
       * 4: 联想词 首位应用
       * 5: 热词 应用
       * 6:  联想词 非首位应用
       */
      dispatch(
        logPostInfo({
          source: 'Search',
          source_p: logInfoData.source,
          source_pp: logInfoData.source_p,
          search_word: props.value || v.keyWord,
          search_type: index === 0 ? 4 : 6,
        }),
      );
    },
    [dispatch, props],
  );

  const handleSelectKw = useCallback(
    v => {
      // 联想词点击
      dispatch(
        logging({
          category: 'C',
          action: 'Search_Lenovo_Word',
          label: '',
          param2: {
            source: 'Search',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            search_type: 2,
            search_word: props.value,
            lenovo_word: v.keyWord,
          },
          param3: v.bizInfo,
        }),
      );
      // search_type 1: 热词    2: 联想词   3: 搜索词   4: 联想词 首位应用
      dispatch(
        logPostInfo({
          source: 'Search',
          source_p: logInfoData.source,
          source_pp: logInfoData.source_p,
          // search_word: props.value,
          search_word: v.keyWord,
          search_type: 2,
        }),
      );
      // 新搜索时页面滚动到顶部
      document.getElementById('container_content').scrollTo(0, 0);
    },
    [dispatch, props],
  );

  const hanldeLink = (v = {}) => () => {
    if (v.targetText) {
      // 联想词点击
      dispatch(
        logging({
          category: 'C',
          action: 'Search_Lenovo_Word',
          label: '',
          param2: {
            source: 'Search',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            search_type: 2,
            search_word: props.value,
            lenovo_word: v.keyWord,
          },
          param3: v.bizInfo,
        }),
      );
      window.open(v.targetUrl);
    }
  };

  return (
    (lenovoWords && lenovoWords.data && lenovoWords.data.length > 0 && (
      <div className={styles.popus} onMouseDown={handleStopProp} onTouchStart={handleStopProp}>
        <div className="list-wrapper">
          {lenovoWords.data.slice(0, 6).map((v, i) => {
            // 1-PC应用,2-android应用,3-商店搜索结果banner,4-浏览器搜索跳转专题和壁纸页面,5-商店联想词广告()
            if (v.spread === '1' && (v.itemType === 1 || v.itemType === 2)) {
              return (
                <div
                  className={props.changeIndex === i ? 'line-soft active' : 'line-soft'}
                  onClick={() => {
                    handleSoft(v, i);
                  }}
                  key={`${i}_${v.softName}`}
                >
                  <SoftCardSearch
                    soft={{
                      ...v,
                      softName: v.keyWord, // 补坑处理
                      softNameShow: v.softName,
                    }}
                    lenovoWords={lenovoWords}
                    // 联系词softcard 做特殊处理  （card里面的事件先执行）  参数通过父组件传入
                    // 首位应用进入详情页面的时候，重置两次logPostInfo（即：让source，source_p，source_p后移一步，logInfo.source = 'Search'）
                    // 详情页中通过source_p==='Search'判断来源是否来自搜索
                    logInfo={{
                      isSearch: true,
                      source: 'Search',
                      source_p: logInfoData.source,
                      source_pp: logInfoData.source_p,
                      search_type: i === 0 ? 4 : 6,
                      search_word: props.value,
                      changeIndex: props.changeIndex,
                    }}
                    firstapp={i === 0}
                  />
                </div>
              );
            }
            if (v.itemType === 5) {
              return (
                <div
                  className={classNames(
                    props.changeIndex === i ? 'line active' : 'line',
                    styles.soft_text,
                  )}
                  key={`${i}_${v.targetText}`}
                  onClick={hanldeLink(v)}
                  dangerouslySetInnerHTML={{ __html: v.targetText }}
                />
              );
            }
            // (v.spread === '1' && (v.itemType !== 1 || v.itemType !== 2)) ||
            // (v.spread !== '1' && v.itemType !== 5
            return (
              <Link
                className={props.changeIndex === i ? 'line active' : 'line'}
                key={`${i}_${v.softName}`}
                to={`${CONTEXT}/search/soft?keyword=${encodeURIComponent(v.keyWord)}`}
                onClick={() => {
                  handleSelectKw(v);
                }}
                dangerouslySetInnerHTML={{ __html: v.softName }}
              />
            );
          })}
        </div>
      </div>
    )) ||
    null
  );
});
